import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-DownArrow",
  "use": "svg-icon-DownArrow-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol viewBox=\"0 0 12 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-DownArrow\"><path d=\"M6 6.75l-.825-.816L.171.984a.572.572 0 0 1 0-.815.588.588 0 0 1 .825 0L6 5.119l5.004-4.95a.588.588 0 0 1 .825 0 .572.572 0 0 1 0 .816l-5.004 4.95L6 6.75z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol